
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sneeuwhoogtes-sneeuwbericht",
      function () {
        return require("private-next-pages/sneeuwhoogtes-sneeuwbericht.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sneeuwhoogtes-sneeuwbericht"])
      });
    }
  